import Url from '../global/Url';

async function getCampaigns(Parametro) {
    try {
        const response = await fetch(Url.Crm + 'campanias?parametro=' + encodeURIComponent(Parametro));
        const responseJson = await response.json();
        return responseJson.body;
    } catch (error) {
        console.error(`ERROR CAMPANIAS: ${error}`);
    }
}

export { getCampaigns };
